export const palette_3m_9000 = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#28282b" : {
        display: "Gece Mavisi LLumar Özel Seri",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
}